<div
  *ngIf="this.orderDetails?.budgetPaymentHistory &&
  this.orderDetails?.budgetPaymentHistory?.length == 1 &&
  this.orderDetails?.budgetPaymentHistory[0].budgetType === BudgetType.General"
  class="d-flex justify-content-between">
  <div>
    {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_BENEFITS_BUDGET' | translate }}
  </div>
  <div class="semi-bold dark-green text-right">
    {{ benefitPrice | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
  </div>
</div>
<div
     *ngIf="this.orderDetails?.budgetPaymentHistory &&
     this.orderDetails?.budgetPaymentHistory?.length >= 1 &&
     this.orderDetails?.budgetPaymentHistory[0].budgetType !== BudgetType.General">
  <div *ngFor="let budget of this.orderDetails?.budgetPaymentHistory;" class="d-flex justify-content-between">
    <div *ngIf="budget.budgetType === BudgetType.General" class="bg-primary">
      {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_STANDARD_BENEFITS_BUDGET' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.General" class="semi-bold dark-green text-right">
      {{ budget.amount | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.Transport">
      {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_TRANSPORT_BENEFITS_BUDGET' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.Transport" class="semi-bold dark-green text-right">
      {{ budget.amount | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.ProfessionalDevelopment">
      {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_PROFESSIONAL_DEVELOPMENT_BENEFITS_BUDGET' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.ProfessionalDevelopment" class="semi-bold dark-green text-right">
      {{ budget.amount | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.Cashback">
      {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_CASHBACK_BUDGET' | translate }}
    </div>
    <div *ngIf="budget.budgetType === BudgetType.Cashback" class="semi-bold dark-green text-right">
      {{ budget.amount | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
    </div>
  </div>
</div>
